import { resiL3DataEn } from "constants-lib/seo/resiL3Data"
import { smbL3DataEn } from "constants-lib/seo/smbL3Data"
import { troL3DataEn } from "constants-lib/seo/troL3Data"
import { dropOffDataEn, dropOffDataFr } from "constants-lib/seo/dropOffData"
import { tro10DataEn, tro10ProductDataEn } from "constants-lib/seo/tro10Data"
import { tro12DataEn, tro12ProductDataEn } from "constants-lib/seo/tro12Data"
import { tro15DataEn, tro15ProductDataEn } from "constants-lib/seo/tro15Data"
import { tro20DataEn, tro20ProductDataEn } from "constants-lib/seo/tro20Data"
import { tro30DataEn, tro30ProductDataEn } from "constants-lib/seo/tro30Data"
import { tro40DataEn, tro40ProductDataEn } from "constants-lib/seo/tro40Data"
import { addRemoveJSONLD, addSchemaDirectly } from "./jsonLD.js"

export const addSchemaDetails = () => {
  // Add Residential L3 page schema details for us/en locale
  addRemoveJSONLD(
    `resiL3JSONLD`,
    `/us/en/home/residential-waste-recycling-pickup`,
    resiL3DataEn,
  )

  // Add SMB L3 page schema details for us/en locale
  addRemoveJSONLD(
    `smbL3JSONLD`,
    `/us/en/business/business-waste-recycling-pickup`,
    smbL3DataEn,
  )

  // Add TRO L3 page schema details for us/en locale
  addRemoveJSONLD(`troL3JSONLD`, `/us/en/dumpster-rental`, troL3DataEn, true)

  // Add Drop off Locations page schema details for us/en locale
  addRemoveJSONLD(
    `dropOffJSONLD`,
    `/us/en/drop-off-locations`,
    dropOffDataEn,
    true,
  )

  // Add Drop off Locations page schema details for ca/fr locale
  addRemoveJSONLD(
    `dropOffJSONLD`,
    `/fr/drop-off-locations`,
    dropOffDataFr,
    true,
  )

  // Add Home page schema details for us/en locale
  // addRemoveJSONLD(
  //  `homeJSONLD`,
  //  `/`,
  //  homeDataEn,
  // )

  // Add TRO 10-yard page schema details for us/en locale
  addSchemaDirectly(
    `tro10JSONLD`,
    `/us/en/dumpster-rental/10-yard`,
    tro10DataEn,
  )

  // Add TRO 10-yard page schema details for us/en locale with product
  addSchemaDirectly(
    `tro10JSONLDProduct`,
    `/us/en/dumpster-rental/10-yard`,
    tro10ProductDataEn,
  )

  // Add TRO 12-yard page schema details for us/en locale
  addSchemaDirectly(
    `tro12JSONLD`,
    `/us/en/dumpster-rental/12-yard`,
    tro12DataEn,
  )

  // Add TRO 12-yard page schema details for us/en locale with product
  addSchemaDirectly(
    `tro12JSONLDProduct`,
    `/us/en/dumpster-rental/12-yard`,
    tro12ProductDataEn,
  )

  // Add TRO 15-yard page schema details for us/en locale
  addSchemaDirectly(
    `tro15JSONLD`,
    `/us/en/dumpster-rental/15-yard`,
    tro15DataEn,
  )

  // Add TRO 15-yard page schema details for us/en locale with product
  addSchemaDirectly(
    `tro15JSONLDProduct`,
    `/us/en/dumpster-rental/15-yard`,
    tro15ProductDataEn,
  )

  // Add TRO 20-yard page schema details for us/en locale
  addSchemaDirectly(
    `tro20JSONLD`,
    `/us/en/dumpster-rental/20-yard`,
    tro20DataEn,
  )

  // Add TRO 20-yard page schema details for us/en locale with product
  addSchemaDirectly(
    `tro20JSONLDProduct`,
    `/us/en/dumpster-rental/20-yard`,
    tro20ProductDataEn,
  )

  // Add TRO 30-yard page schema details for us/en locale
  addSchemaDirectly(
    `tro30JSONLD`,
    `/us/en/dumpster-rental/30-yard`,
    tro30DataEn,
  )

  // Add TRO 30-yard page schema details for us/en locale with product
  addSchemaDirectly(
    `tro30JSONLDProduct`,
    `/us/en/dumpster-rental/30-yard`,
    tro30ProductDataEn,
  )

  // Add TRO 40-yard page schema details for us/en locale
  addSchemaDirectly(
    `tro40JSONLD`,
    `/us/en/dumpster-rental/40-yard`,
    tro40DataEn,
  )

  // Add TRO 40-yard page schema details for us/en locale with product
  addSchemaDirectly(
    `tro40JSONLDProduct`,
    `/us/en/dumpster-rental/40-yard`,
    tro40ProductDataEn,
  )
}
